module.exports = __webpack_public_path__ + "static/media/Einladung_Mitgliederversammlung_2021.326e0b73.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/Einladung_Mitgliederversammlung_2021.pdf
// module id = 110
// module chunks = 0